export const redesignRouteRegex = /\/n(\/|$)/g

export function hasRedesignRoute(path: string): boolean {
  return redesignRouteRegex.test(path)
}

export function removeRedesignRoute(path: string) {
  return path.replace(redesignRouteRegex, '/')
}
